<template lang="pug">
.modal
  header.header-area 復元するシミュレーション
  p.desc-saved 復元するシミュレーションのIDを入力ください。
  .area-content
    label.save シミュレーションID（必須）
    input.save-input(
    type="text",
    placeholder="Id",
    v-model="id"
  )
  p.error(v-if="errorMessage") ID に誤りがあります。お手数ですが、再度ご入力をお願いいたします。
  footer
    button.close(@click="close")
      | 閉じる
    button(@click="submitSaved")
      | 確認
      img(src="@/assets/ico_arrow_right.svg")
</template>
<script>
export default {
  name: 'SavedArea',
  data () {
    return {
      id: ''
    };
  },
  props: {
    errorMessage: Boolean
  },
  methods: {
    close () {
      this.$emit('close');
    },
    submitSaved () {
      this.$emit('submitSaved', this.id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.modal
  .header-area
    margin: 0;
    padding: 20px 30px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #dddddd;
  .desc-saved
    padding: 0 30px;
  .area-content
    display: flex;
    align-items: center;
    padding: 10px 30px;
    position: absolute;
    left: 0;
    right: 0;
    top: 72px;
    bottom: 73px;
    overflow-y: auto;
    label
      font-size: 18px;
      font-weight: bold;
    input
      height: 33px;
      padding: 0 5px;
      font-weight: bold;
      font-size: 16px;
      border 1px solid #ddd;
      border-radius: 2px;
  .error
    color: red;
    margin-top: 65px;
    margin-left: 35px;
.area-content-email
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  background-color: #ffffff;
  position: absolute;
  left: 0;
  right: 0;
  top: 72px;
  bottom: 73px;
  overflow-y: auto;
  label
    font-size: 18px;
    font-weight: bold;
  input
    height: 33px;
    padding: 0 5px;
    font-weight: bold;
    font-size: 16px;
    border 1px solid #ddd;
    border-radius: 2px;
.save-simulation
  .vm--modal
    width: 570px !important;
    height: 300px !important;
footer
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 73px;
  padding: 20px 30px;
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  button
    background-color: #2E7C80;
    width: 180px;
    height: 33px;
    border: none;
    border-radius: 5px;
    color: #ffffff;
    font-weight: bold;
    font-size: 14px;
    margin-left: 15px;
    &[disabled], background-color #aaaaaa, &:hover
      opacity: 1;
    img
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
      margin-top: -2px;
  .close
    background-color: #999;
    width: 150px;
    height: 33px;
    border: none;
    border-radius: 5px;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
</style>



// WEBPACK FOOTER //
// src/components/save/SavedArea.vue